<template>
  <div class="leftPanel fl">
    <ul class="bg_fff">
      <li v-for="(item,index) in linkData" :key="String(index)" style="cursor: pointer;" @click="toTab(item.index)">
        <div class="list-item f_16" :class="[index === currentIndex  ? 'active color_40' : 'color_60']">
          <span class="active-border"></span>
<!--          <a :href="item.url" :class="[index === currentIndex ? 'color_40' : 'color_60']">{{item.title}}</a>-->
          <span :class="[index === currentIndex ? 'color_40' : 'color_60']">{{item.title}}</span>
        </div>
      </li>
    </ul>
  </div>

</template>
<script>
import { get_tUser } from '@/assets/js/util';
import api from '@/api';
const linkData = [
  {
    title:'基本信息',
    url:'/account/users',
    index: 0
  },
  {
    title:'账号设置',
    url:'/account/settings',
    index: 1
  },
  {
    title:'隐私设置',
    url:'/account/privacy',
    index: 2
  },
  /* {
    title:'优惠活动',
    url:'/account/users/current',
  },  */
  {
    title:'我的订单',
    url:'/account/orders',
    index: 3
  },
  {
    title:'设备管理',
    url:'/account/equipmentManagement',
    index: 4
  }
]
export default {
  name: 'leftPanel',
  props:{
    currentIndex:{
      type: [Number, String],
      default: 0,
    },
    showPrivacy: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return {
      user: {},
      linkData
    }
  },
  watch: {
    showPrivacy: {
      handler(newVal) {
        let data = JSON.parse(JSON.stringify(linkData))
        if (!newVal) {
          data.splice(2, 1)
        }
        this.linkData = data
      },
      immediate: true
    }
  },
  computed: {},
  mounted() {
  },
  methods:{
    toTab(index) {
      // this.$router.push(url);
      this.$emit('toTab', index);
    }
  }
}
</script>
<style lang="scss" scoped>
  // 公共初始化样式
  @import '~/assets/css/public';
  .leftPanel{
    width: 260px;
    ul{
      list-style: none;
      border-radius: 2px;
      overflow: hidden;
      box-shadow: 0px 2px 4px 0px rgba(1, 35, 99, 0.04);
      li{
        height: 112px;
        position: relative;
        list-style: none;
        .list-item{
          width: 238.5px;
          height: 112px;
          border-bottom: 1px solid #F5F5F7;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
          .active-border {
            width: 8px;
            height: 26px;
            background: #FF4F4C;
            position: absolute;
            top: 50%;
            margin-top: -13px;
            left: 56px;
            display: none;
          }
          &.active .active-border{
            display: inline-block;
          }
        }
        &:last-child{
          .list-item{
            border: 0;
          }
        }
      }
    }
  }
</style>
